import type { KeywordBankRun } from "@/types";

/**
 * AUT-196 follow-up: "the product is still importing" for the four
 * product-detail surfaces that show a pending state while the keyword bank
 * seeds (header KPIs, A/B Tests, Landscapes, Search Terms).
 *
 * "Still importing" is exactly the two *actively seeding* statuses --
 * `queued` or `running` -- the same branch `KeywordBankBuildState` renders as
 * "Building your keyword bank".
 *
 * Deliberately NOT `isRunInFlight` (`src/utils/landscapeRunStatus.ts`): that
 * predicate also returns true for `stopped`, and a stopped run is not
 * importing -- showing "please wait, still importing" for a run that has gone
 * quiet would be a lie. `null` (a pre-feature product that never ran an
 * import, FR-9), `undefined` (the run not loaded yet, or a settled error) and
 * every ending status are all "not importing" and fall through to each
 * surface's existing empty/no-data state.
 */
export function isKeywordBankImporting(run: KeywordBankRun | null | undefined): boolean {
  if (run === null || run === undefined) return false;
  return run.status === "queued" || run.status === "running";
}
